import './CloudCostsUsage.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ProgressBar } from '../../../__legacy__/components/ProgressBar';
import { AccountInfinityLimit } from '../../../__legacy__/modules/user/components/AccountInfinityLimit';

interface IProps {
  limit: number;
  used: number;
}

export const CloudCostsUsage = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { limit, used } = props;

  const allZerosOrExceededZero = used >= limit && limit === 0;

  return (
    <div className='cloud-costs-usage'>
      <div className='cloud-costs-header'>
        <h5 className='cloud-costs-header-header'>{t('cloud_costs.current_usage')}</h5>
        <div>
          {Math.ceil(used * 100)}/{limit < 0 ? <AccountInfinityLimit /> : <span>{Math.ceil(limit * 100)}</span>} {t('credits')}
        </div>
      </div>
      <div className={`right limit ${limit >= 0 && used > limit ? 'exceeded' : ''}`}>
        {limit >= 0 && (
          <ProgressBar
            // Workaround for bug causing progress bar to not update when limit is set to 0
            value={allZerosOrExceededZero ? 1 : used}
            max={allZerosOrExceededZero ? 1 : limit}
          />
        )}
      </div>
    </div>
  );
});
